import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Plane,
    User,
    MapPin,
    Calendar,
    ArrowRight,
    ShieldCheck,
    Globe
} from 'lucide-react';

const OnboardingView = ({ onComplete }) => {
    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        visitorType: 'Non-resident',
        arrivalDate: '2026-03-01',
        airport: 'Murtala Muhammed (MMIA)',
        nationality: 'United Kingdom'
    });

    const nextStep = () => setStep(step + 1);

    const handleFinish = () => {
        // Preserve local storage for "Onboarded" status
        localStorage.setItem('ez_onboarded', 'true');
        localStorage.setItem('user_name', formData.name);
        onComplete();
    };

    return (
        <div className="onboarding-view animate-fade">
            {step === 1 && (
                <div className="onboard-step">
                    <div className="hero-emoji">👋</div>
                    <h1>Welcome to Lagos</h1>
                    <p>The ultimate visitor companion for Nigeria's most vibrant city.</p>
                    <div className="feature-badges">
                        <span className="badge"><ShieldCheck size={14} /> Verified Staff</span>
                        <span className="badge"><Globe size={14} /> Local Guide</span>
                    </div>
                    <button className="primary-btn lg full-width" onClick={nextStep}>
                        Start Setup <ArrowRight size={20} />
                    </button>
                </div>
            )}

            {step === 2 && (
                <div className="onboard-step">
                    <h2>Create Profile</h2>
                    <div className="form-group-o">
                        <label>What's your full name?</label>
                        <input
                            type="text"
                            placeholder="Full Name"
                            value={formData.name}
                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        />
                    </div>
                    <div className="form-group-o">
                        <label>Visitor Type</label>
                        <select
                            value={formData.visitorType}
                            onChange={(e) => setFormData({ ...formData, visitorType: e.target.value })}
                        >
                            <option value="Non-resident">Non-resident / Tourist</option>
                            <option value="Resident">New Resident</option>
                            <option value="Diaspora">Returnee / Diaspora</option>
                        </select>
                    </div>
                    <button className="primary-btn full-width" onClick={nextStep}>Continue</button>
                </div>
            )}

            {step === 3 && (
                <div className="onboard-step">
                    <h2>Arrival Details</h2>
                    <div className="form-group-o">
                        <label>Arrival Date</label>
                        <input
                            type="date"
                            value={formData.arrivalDate}
                            onChange={(e) => setFormData({ ...formData, arrivalDate: e.target.value })}
                        />
                    </div>
                    <div className="form-group-o">
                        <label>Arrival Airport</label>
                        <input
                            type="text"
                            readOnly
                            value={formData.airport}
                            style={{ background: '#f0f0f0' }}
                        />
                    </div>
                    <div className="form-group-o">
                        <label>Nationality</label>
                        <input
                            type="text"
                            placeholder="Nationality"
                            value={formData.nationality}
                            onChange={(e) => setFormData({ ...formData, nationality: e.target.value })}
                        />
                    </div>
                    <button className="primary-btn full-width" onClick={handleFinish}>Finish Setup</button>
                </div>
            )}

            <div className="step-dots">
                {[1, 2, 3].map(i => <span key={i} className={`dot ${step === i ? 'active' : ''}`}></span>)}
            </div>

            <style dangerouslySetInnerHTML={{
                __html: `
        .onboarding-view {
          height: 100vh;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 40px;
          background: white;
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 5000;
          max-width: 480px;
          margin: 0 auto;
        }
        .onboard-step { text-align: center; }
        .hero-emoji { font-size: 64px; margin-bottom: 20px; }
        .onboard-step h1 { font-size: 32px; margin-bottom: 12px; }
        .onboard-step h2 { margin-bottom: 24px; text-align: left; font-size: 24px; }
        .onboard-step p { color: var(--text-light); margin-bottom: 40px; }
        
        .feature-badges { display: flex; gap: 10px; justify-content: center; margin-bottom: 40px; }
        .badge { display: flex; align-items: center; gap: 6px; font-size: 11px; background: var(--light-green); color: var(--primary-green); padding: 6px 14px; border-radius: 20px; font-weight: 700; }
        
        .form-group-o { text-align: left; margin-bottom: 20px; }
        .form-group-o label { font-size: 13px; font-weight: 700; color: var(--text-dark); margin-bottom: 8px; display: block; }
        .form-group-o input, .form-group-o select { width: 100%; padding: 14px; border: 1px solid var(--border-gray); border-radius: var(--radius-md); font-family: inherit; font-size: 16px; }

        .step-dots { display: flex; gap: 8px; justify-content: center; margin-top: 40px; }
        .dot { width: 8px; height: 8px; border-radius: 50%; background: var(--border-gray); }
        .dot.active { background: var(--primary-green); width: 20px; border-radius: 4px; }
        
        .lg { padding: 16px; font-size: 18px; display: flex; align-items: center; justify-content: center; gap: 12px; }
        .full-width { width: 100%; }
      `}} />
        </div>
    );
};

export default OnboardingView;
